/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type CreateCommentMutation_viewer = {
    readonly role: USER_ROLE;
    readonly createdAt: string;
    readonly badges: ReadonlyArray<string> | null;
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
        readonly ban: {
            readonly active: boolean;
        };
    };
    readonly " $refType": "CreateCommentMutation_viewer";
};
export type CreateCommentMutation_viewer$data = CreateCommentMutation_viewer;
export type CreateCommentMutation_viewer$key = {
    readonly " $data"?: CreateCommentMutation_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentMutation_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCommentMutation_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "badges",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "current",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "BanStatus",
                    "kind": "LinkedField",
                    "name": "ban",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '074f5279aab94f8b50e2cdaf6ceff490';
export default node;
